'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _arrowDown = require('dibs-vg/dist/react/arrow-down');

var _arrowDown2 = _interopRequireDefault(_arrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandingArea = function (_React$Component) {
    (0, _inherits3.default)(ExpandingArea, _React$Component);

    function ExpandingArea(props) {
        (0, _classCallCheck3.default)(this, ExpandingArea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ExpandingArea.__proto__ || (0, _getPrototypeOf2.default)(ExpandingArea)).call(this, props));

        _this.state = {
            isFullyExpanded: props.showOverflow && props.expanded
        };
        return _this;
    }

    (0, _createClass3.default)(ExpandingArea, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.showOverflow && this.props.expanded !== nextProps.expanded) {
                // need to remove overflow scroll when fully expanded
                // 200ms is css transition time
                var timeout = nextProps.expanded ? 200 : 0;
                setTimeout(function () {
                    _this2.setState({ isFullyExpanded: nextProps.expanded });
                }, timeout);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isFullyExpanded = this.state.isFullyExpanded;
            var _props = this.props,
                children = _props.children,
                dataTn = _props.dataTn,
                expanded = _props.expanded,
                label = _props.label,
                labelClass = _props.labelClass,
                maxHeight = _props.maxHeight,
                showArrow = _props.showArrow,
                onClick = _props.onClick,
                wrapperClass = _props.wrapperClass,
                theme = _props.theme,
                expandingAreaClass = _props.expandingAreaClass;


            if (!theme) {
                return null;
            }

            var labelStyles = (0, _classnames5.default)(theme.labelWrapper, (0, _defineProperty3.default)({}, theme.stringLabel, typeof label === 'string' || showArrow), labelClass);

            var arrowStyles = (0, _classnames5.default)(theme.arrow, (0, _defineProperty3.default)({}, theme.arrowUp, expanded));

            var expandingAreaClassName = (0, _classnames5.default)(theme.expandingArea, (0, _defineProperty3.default)({}, theme.expanded, isFullyExpanded), expandingAreaClass);

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                label && _react2.default.createElement(
                    'div',
                    { className: labelStyles, 'data-tn': dataTn, onClick: onClick },
                    _react2.default.createElement(
                        'div',
                        { className: theme.label },
                        label
                    ),
                    (typeof label === 'string' || showArrow) && _react2.default.createElement(_arrowDown2.default, { className: arrowStyles })
                ),
                children && _react2.default.createElement(
                    'div',
                    { className: expandingAreaClassName, style: { maxHeight: expanded ? maxHeight : "0px" } },
                    children
                )
            );
        }
    }]);
    return ExpandingArea;
}(_react2.default.Component);

ExpandingArea.defaultProps = {
    expanded: false
};


ExpandingArea.defaultProps = {
    showArrow: false,
    maxHeight: "90vh"
};

ExpandingArea.displayName = 'ExpandingArea';

exports.default = ExpandingArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/ExpandingArea/index.js
// module id = ./node_modules/dibs-elements/lib/ExpandingArea/index.js
// module chunks = 4